module.exports = __webpack_public_path__ + "img/schema-info.7c597b79.gif";